import React from 'react';

const TextModule = ({config}) => {
	return (
		<div style={{padding: '16px', border: '1px solid #dcdcdc', borderRadius: '6px'}}>
			<h5 style={{marginTop: 0}}>{config.title || 'Information'}</h5>
			<p style={{marginBottom: 0}}>{config.body || ''}</p>
		</div>
	);
};

export default TextModule;
